<template>
  <div class="layout-app" :class="current_mode">
      <div id="dropdown" />
      <div class="top-nav flex items-center justify-between p-5 px-12">
          <a :href="route('home')"><logo class="top_logo" /></a>
          <div class="flex justify-center items-center">
              <dropdown class="mt-1 language_menu_wrapper absolute right-12 top-3" placement="bottom-end">
                  <template #default>
                      <div class="flex justify-between items-center cursor-pointer group language_menu">
                          <div class=" font-bold mr-1 whitespace-nowrap flex justify-center item-center gap-2">
                              <icon class="w-5 h-5" :name="selected_language.code" /> <span>{{ selected_language.name }}</span>
                          </div>
                          <icon class="w-5 h-5 drop-down-caret-icon" name="cheveron-down" />
                      </div>
                  </template>
                  <template #dropdown>
                      <div class=" py-2 shadow-xl rounded text-sm language_menu_list">
                          <Link v-for="language in languages_except_selected" :key="language.code" class="flex items-center justify-center gap-2 px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('language', [language.code])">
                              <icon class="w-5 h-5" :name="language.code" /> <span class="lang_name">{{ language.name }}</span>
                          </Link>
                      </div>
                  </template>
              </dropdown>
          </div>
      </div>
      <flash-messages />
      <div class="sec-cont">
          <slot />
      </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import FlashMessages from '@/Shared/FlashMessages'
import Dropdown from '@/Shared/Dropdown'
import LanguageSelector from '@/Shared/LanguageSelector'
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        FlashMessages,
        Icon,
        Logo,
        Link,
        LanguageSelector,
        Dropdown,
    },
    props: {
        title: String,
    },
    data() {
        return{
            languages: [
                {name: '繁體中文', code: 'cn'},
                {name: 'English', code: 'en'},
            ],
            current_mode: 'light',
            modes: ['dark', 'light'],
            edit_route: ''

        }
    },
    computed: {
        selected_language() {
            return this.languages.find(language => language.code === this.$page.props.locale)
        },
        languages_except_selected(){
            return this.languages.filter(language => language.code !== this.$page.props.locale)
        }
    },
    methods:{
    },
    updated() {
    },
    created() {

    }
}
</script>
